module.exports = __webpack_public_path__ + "img/logo-old.9a3cff82.svg";